var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('sidebar.shortTitle'),"logo":_vm.$store.getters.systemLogoSidebar,"title":_vm.$store.getters.systemTile},scopedSlots:_vm._u([{key:"links",fn:function(props){return [_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: '/dashboard'
        }}}),_c('sidebar-item',{attrs:{"link":{ 
            name: _vm.$t('sidebar.empresas'),
            path: '/empresa/list',
            icon: 'tim-icons icon-bank' 
          }}}),_c('sidebar-item',{attrs:{"link":{ 
            name: _vm.$t('sidebar.usuarios'),
            path: '/usuario/list',
            icon: 'tim-icons icon-single-02' 
          }}}),_c('sidebar-item',{attrs:{"link":{ 
            name: _vm.$t('sidebar.prazosEntrega'),
            path: '/rotaPrazoEntrega/editTransportador',
            icon: 'tim-icons icon-square-pin' 
          }}}),_c('sidebar-item',{attrs:{"link":{ 
            name: _vm.$t('sidebar.ocorrenciasdepara'),
            path: '/tabelaOcorrenciaDePara/deParaEmbarcador',
            icon: 'tim-icons icon-bullet-list-67' 
          }}}),_c('sidebar-item',{attrs:{"link":{ name: _vm.$t('sidebar.importacoes'), icon: 'tim-icons icon-upload' }}},[_c('sidebar-item',{attrs:{"link":{ 
            name: _vm.$t('sidebar.nfe'), 
            path: '/notaFiscal/import',
            icon: 'tim-icons icon-upload' 
          }}}),_c('sidebar-item',{attrs:{"link":{ 
            name: _vm.$t('sidebar.cte'), 
            path: '/cte/import',
            icon: 'tim-icons icon-upload' 
          }}}),_c('sidebar-item',{attrs:{"link":{ 
            name: _vm.$t('sidebar.edi'), 
            path: '/entregaOcorrencia/import',
            icon: 'tim-icons icon-upload' 
          }}})],1),_c('sidebar-item',{attrs:{"link":{ 
            name: 'Entregas', 
            path: '/entrega/list',
            icon: 'tim-icons icon-world' 
          }}})]}}])}),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar',{attrs:{"module":"tracking"}}),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }